import NameDialogData from './NameDialogData'
import MessageDialogData from './MessageDialogData'
import AvgButton from '../../ComControl/AvgButton'
import { FileReader, FileWriter } from '@/platform'

class TalkMessageData {
    /**
     * 头像显示的类型
     */
    public FaceStyle: number = 0

    /**
     * 选项的背景图片
     */
    public SelectButton: number = 0

    /**
     * 对话框
     */
    public TalkWin: MessageDialogData = new MessageDialogData()

    /**
     *  选项图片  project_bin_no
     */
    public SelectPic: number = 0

    /**
     * 姓名框
     */
    public NameWinS: NameDialogData = new NameDialogData()

    constructor(btn?: AvgButton[]) {
        if (btn !== undefined) {
            this.FaceStyle = 2
            this.SelectButton = 16
            this.SelectPic = 16
            this.NameWinS = new NameDialogData()
            this.TalkWin = new MessageDialogData()
        }
    }

    /** cg_v3_data：FaceStyle → SelectButton → TalkWin → SelectPic → NameWinS */
    readBin(reader: FileReader): void {
        this.FaceStyle = reader.readInt()
        this.SelectButton = reader.readInt()
        this.TalkWin = new MessageDialogData()
        this.TalkWin.readBin(reader)
        this.SelectPic = reader.readInt()
        this.NameWinS = new NameDialogData()
        this.NameWinS.readBin(reader)
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.FaceStyle)
        writer.writeInt(this.SelectButton)
        this.TalkWin.writeBin(writer)
        writer.writeInt(this.SelectPic)
        this.NameWinS.writeBin(writer)
    }

    readVersionedOui(reader: FileReader): void {
        this.FaceStyle = reader.readInt()
        this.SelectButton = reader.readInt()
        this.TalkWin.readVersionedOui(reader.readObj(reader.readInt()))
        this.SelectPic = reader.readInt()
        this.NameWinS.readVersionedOui(reader.readObj(reader.readInt()))
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.FaceStyle)
        writer.writeInt(this.SelectButton)
        this.TalkWin.writeVersionedOui(writer)
        writer.writeInt(this.SelectPic)
        this.NameWinS.writeVersionedOui(writer)

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.FaceStyle)
        writer.writeInt(this.SelectButton)
        this.TalkWin.writeGameBin(writer)
        this.NameWinS.writeGameBin(writer)
        writer.writerLength()
    }
}

export default TalkMessageData
